import { gql } from "@apollo/client/core";

export default gql`
    mutation DeleteDisasterCategory($id: ID!) {
        deleteDisasterCategory(input: { id: $id }) {
            errors
            status
            statusCode
        }
    }
`
